import { Modal, Box, Typography, Button } from "@mui/material";
import {
  modalBoxStyles,
  messagesContainerStyles,
  buttonsContainerStyles,
  cancelButtonStyles,
  sendButtonStyles,
  loadingBoxStyles,
} from "./styles";
import MessageBubble from "../../chat/chat-bubble/message-bubble";
import { colors } from "../../../colors/colors";
import { previewInfoMesssage } from "../../../axios/admin";
import { AdminCreds, Message, MessageInfo } from "../../../types";
import { useEffect, useState } from "react";

interface MessagePreviewProps {
  open: boolean;
  onClose: () => void;
  messageInfo: MessageInfo;
  adminCreds: AdminCreds;
  setSend: () => void;
}

export const MessagePreview = ({
  open,
  onClose,
  messageInfo,
  adminCreds,
  setSend,
}: MessagePreviewProps) => {
  const [message, setMessage] = useState<Message | null>(null);

  useEffect(() => {
    if (!open) return;

    const fetchMessagePreview = async () => {
      const res = await previewInfoMesssage(messageInfo, adminCreds);
      setMessage(res);
    };

    fetchMessagePreview();
  }, [open, messageInfo]);

  const handleClose = () => {
    setMessage(null);
    onClose();
  };

  const handleSend = () => {
    setSend();
    handleClose();
  };

  if (!message) {
    return (
      <Modal open={open} onClose={handleClose}>
        <Box sx={loadingBoxStyles}>
          <Typography
            variant="body2"
            sx={{
              color: colors.black,
              textAlign: "center",
              fontSize: "1.1em",
            }}
          >
            Loading...
          </Typography>

          <Box sx={buttonsContainerStyles}>
            <Button
              variant="contained"
              onClick={handleSend}
              sx={sendButtonStyles}
            >
              Send
            </Button>
          </Box>
        </Box>
      </Modal>
    );
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalBoxStyles}>
        <Box sx={messagesContainerStyles}>
          <div>
            <MessageBubble
              headerVisible={false}
              scrollToPreviousUserMessage={() => {}}
              scrollToNextUserMessage={() => {}}
              scrollToPreviousLessonMessage={() => {}}
              scrollToNextLessonMessage={() => {}}
              message={message}
              isBot={message.is_bot}
              prevMessageHeight={0}
              hideReactionsButton
            />
          </div>
        </Box>

        <Box sx={buttonsContainerStyles}>
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={cancelButtonStyles}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSend}
            sx={sendButtonStyles}
          >
            Send
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
